var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkingP5 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 350,
  height: 333.331,
  viewBox: "0 0 350 333.331"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "parking_P5_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 249.998h262.5V0H0z"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0072ce",
  d: "m0 0 .016 333.33H350V0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#parking_P5_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 333.33)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M197.315 55.948c0-17.33-12.17-31.353-35.978-31.353-7.15 0-15.478 1.193-21.567 2.646l.402 16.54c4.49-1.85 10.84-4.63 18.917-4.63 9.652 0 19.706 4.498 19.706 16.27 0 11.904-10.584 16.008-21.17 16.008-5.687 0-11.105-.796-16.53-2.515l.92 49.607h53.048v-13.76H159.48l-.39-19.71c2.118.398 4.89.93 8.465.93 12.962 0 29.76-6.087 29.76-30.032M94.02 157.17h-9.646v41.958h9.645c14.184 0 26.2-5.513 26.2-21.47 0-15.955-12.413-20.488-26.2-20.488m-2.37 63.63H56.787V83.304h27.587V135.5h11.62c29.545 0 52.983 11.625 52.983 43.733 0 32.9-27.375 41.57-57.326 41.57"
}))));
export default SvgParkingP5;